/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Thumbs, EffectCoverflow } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectCoverflow]);
export function slider() {
    const cardsSliderSelector = ".cards__list-container.swiper";
    const productRangeSliderSelector = ".product-cards__slider";
    const logoSliderSelector = ".logos__slider";
    const productImageSliderSelector = ".product-page__media.swiper";
    const productThumbSliderSelector = ".product-page__media-thumbs.swiper";
    const imageSliderSelector = ".image-slider__inner.swiper";
    const mediaContentSliderSelector = ".media-content-slider__slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }


    const init = function () {
        // Cards sliders
        const cardsSliders = [];
        const cardsSlidersElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSlidersElements) {
            cardsSlidersElements.forEach(slider => {
                const swiperInstance = new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 1.2,
                    // loop: true,
                    spaceBetween: 15,
                    autoplay: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            const tag = slider.querySelectorAll('.swiper-slide')[index].getAttribute("data-tag");
                            return '<span class="' + className + '" data-tag="' + tag + '">' + tag + "</span>";
                        },
                    },
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: 1.8,
                            spaceBetween: 45,
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    },
                });

                cardsSliders.push(swiperInstance);
            });
        }

        document.querySelectorAll(".swiper-pagination span").forEach((bullet) => {
            bullet.addEventListener("click", function () {
                const tag = this.getAttribute("data-tag"); // Get the tag from the clicked bullet
                const activeSlider = cardsSliders[0]; // Assuming there is only one slider instance

                // Find the slide index with the matching tag
                const slideIndex = Array.from(activeSlider.slides).findIndex((slide) => slide.getAttribute("data-tag") === tag);

                if (slideIndex !== -1) {
                    // Use slideTo to navigate to the slide by index
                    activeSlider.slideTo(slideIndex);
                }
            });
        });

        // Product Cards Slider
        const productRangeSlider = [];
        const productRangeSliderElements = document.querySelectorAll(productRangeSliderSelector);
        if (productRangeSliderElements) {
            productRangeSliderElements.forEach(slider => {
                productRangeSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.35,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Logo Slider
        const logoSlider = [];
        const logoSliderElements = document.querySelectorAll(logoSliderSelector);
        if (logoSliderElements) {
            logoSliderElements.forEach(slider => {

                logoSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 3,
                    autoplay: {
                        delay: 2000,
                    },
                    spaceBetween: 15,
                    pagination: {
                        el: ".logos__slider-pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                    },
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                            pagination: {
                                enabled: false,
                            },
                            navigation: {
                                el: ".logos__slider-navigation",
                                clickable: true,
                                nextEl: '#' + slider.dataset.componentId + " .logos__slider-next",
                                prevEl: '#' + slider.dataset.componentId + " .logos__slider-prev",
                            },
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Product Images Slider
        const productImagesSliderElement = document.querySelector(productImageSliderSelector);
        const productImagesThumbsSliderElement = document.querySelector(productThumbSliderSelector);
        if (productImagesSliderElement && productImagesThumbsSliderElement) {

            const productImagesThumbsSlider = new Swiper(productImagesThumbsSliderElement, {
                loop: false,
                spaceBetween: 30,
                slidesPerView: 3,
                freeMode: true,
                watchSlidesProgress: true,
            });

            const productImagesSlider = new Swiper(productImagesSliderElement, {
                loop: false,
                spaceBetween: 10,
                pagination: {
                    el: ".product-page__slider-pagination",
                    type: "bullets",
                    clickable: true,
                    enabled: true,
                },
                thumbs: {
                    swiper: productImagesThumbsSlider,
                },
                breakpoints: {
                    // when window width is >= 768px
                    992: {
                        pagination: {
                            enabled: false,
                        },
                        navigation: {
                            nextEl: '#' + productImagesSliderElement.dataset.componentId + " .product-page__slider-next",
                            prevEl: '#' + productImagesSliderElement.dataset.componentId + " .product-page__slider-prev",
                        },
                    },
                },
                on: {
                    slideChange: () => {
                        handleSlideChange();
                    },
                    slideChangeTransitionEnd: (swiper) => {
                        handleSlideChangeTransitionEnd(swiper);
                    }
                }
            });
        }

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {

                imageSlider.push(new Swiper(slider, {
                    effect: "coverflow",
                    // loop: true,
                    slidesPerView: "auto",
                    centeredSlides: true,
                    pagination: {
                        el: ".image-slider__slider-pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                    },
                    coverflowEffect: {
                        rotate: 0,
                        stretch: -25,
                        depth: 0,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .image-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .image-slider__button-prev",
                    },
                    breakpoints: {
                        992: {
                            coverflowEffect: {
                                stretch: -100,
                            }
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Media/Content Slider
        const mediaContentSliderElements = document.querySelectorAll(mediaContentSliderSelector);
        if (mediaContentSliderElements) {
            mediaContentSliderElements.forEach(slider => {
                const component = document.getElementById(slider.dataset.componentId);
                const tabs = component.querySelectorAll(".media-content-slider__tab");

                const pagination = component.querySelector(".media-content-slider__pagination");

                const setActiveTab = function (activeIndex) {
                    tabs.forEach((tab, index) => {
                        const isActive = index === activeIndex;
                        tab.classList.toggle("is-active", isActive);
                        tab.setAttribute("aria-current", isActive ? "true" : "false");

                        //Keep the active tab in view when the tab row scrolls (mobile)
                        if (isActive && pagination.scrollWidth > pagination.clientWidth) {
                            pagination.scrollTo({
                                left: tab.offsetLeft - (pagination.clientWidth - tab.offsetWidth) / 2,
                                behavior: "smooth"
                            });
                        }
                    });
                };

                const swiperInstance = new Swiper(slider, {
                    speed: 500,
                    rewind: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .media-content-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .media-content-slider__button-prev",
                    },
                    on: {
                        slideChange: (swiper) => {
                            handleSlideChange();
                            setActiveTab(swiper.realIndex);
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                });

                tabs.forEach(tab => {
                    tab.addEventListener("click", () => {
                        swiperInstance.slideTo(parseInt(tab.dataset.slideIndex, 10));
                    });
                });
            })
        }
    }

    init();

}
